import { IActivityDetail } from './iactivity-detail';

export interface IDiuresisColorCodeableConcept {
    coding: string;
    text: string;
    // activityDetail: IActivityDetail[];
}
